import { CookiesContent } from "@/components/legal/CookiesContent";

const CookiesPage = () => {
  return (
    <div className="text-gray-900 px-6 py-16 max-w-5xl mx-auto">
      <CookiesContent withPageTitle />
    </div>
  );
};

export default CookiesPage;
